import { createAccessibilityController, createThemeController } from '@semply/theme';

/**
 * Thème du portail.
 *
 * Une seule instance pour toute l'application : le contrôleur écrit sur
 * `:root`, deux instances se marcheraient dessus.
 *
 * Le portail ne connaît PAS l'utilisateur avant sa connexion — il ne peut donc
 * pas lui servir sa palette. Ce qu'il peut faire, et fait ici, c'est
 * respecter le réglage clair/sombre de son système, et retenir un choix
 * explicite. Le jour où la palette du compte redescendra du service d'auth,
 * c'est ici qu'elle s'appliquera, après identification.
 */
export const theme = createThemeController({ storageKey: 'semply-theme' });

/**
 * Réglages d'accessibilité (taille du texte, contraste renforcé, réduction
 * des animations) : le même menu que dans les produits, dès l'écran de
 * connexion — c'est le premier écran vu, celui où un texte trop petit arrête
 * quelqu'un avant même d'entrer.
 */
export const a11y = createAccessibilityController();
